<template>
  <wallet-card>
    <template #header>
      <div title="Finished" class="finishedribbon" v-if="isFinished">
        <div title="Finished">Finished</div>
      </div>
      <div title="Finished" class="finishedribbon" v-else-if="isFull">
        <div title="Finished">Full</div>
      </div>
      <img src="/assets/sf/image/icon_grad.png" class="header__icon" />
      <strong class="header__title">{{ itemData.title }}</strong>
      <small class="header__note">
        {{ itemData.description }}
      </small>
      <span class="header__tag">Manual</span>
    </template>

    <template #body>
      <p class="apy">
        <em class="apy__label">APR：</em>
        <span class="apy__num">{{ toFormattedApr(itemData.apr) }}%</span>
      </p>

      <p class="body-box body-box--earned">
        <span class="body-box__label"
          >{{ itemData.rewardTokenSymbol }} Earned</span
        >
        <em
          :class="[
            'body-box__num',
            { '--none': !$store.state.isLogin && itemData.account.earned <= 0 },
          ]"
          >{{
            $store.state.isLogin && itemData.account.earned >= 0
              ? toFormattedToken(itemData.account.earned)
              : "0.00000"
          }}</em
        >
        <input-button
          :size="'medium'"
          :disabled="!$store.state.isLogin || itemData.account.earned <= 0"
          @click="harvest(itemData)"
          >Harvest</input-button
        >
      </p>
      <p
        class="body-box body-box--staked"
        v-if="itemData.apr == 0 || isFinished"
      >
        <input-button :size="'large'" :disabled="true"
          >Connect Wallet</input-button
        >
      </p>
      <p class="body-box body-box--staked" v-else>
        <template
          v-if="
            $store.state.isLogin &&
            itemData.account.isApproved &&
            itemData.account.staked > 0
          "
        >
          <span class="body-box__label"
            >{{ itemData.stakeTokenSymbol }} Staked</span
          >
          <em class="body-box__num">{{
            toFormattedToken(itemData.account.staked)
          }}</em>
          <span class="staked-buttons">
            <button class="staked-button" @click="withdraw(itemData)">
              <svg-icon class="icon" :icon="'minus'" />
            </button>
            <button
              class="staked-button"
              @click="deposit(itemData)"
              v-if="!isFinished && !isFull"
            >
              <svg-icon class="icon" :icon="'plus'" />
            </button>
          </span>
        </template>
        <input-button
          v-else-if="
            $store.state.isLogin &&
            !itemData.account.isApproved &&
            (!isFinished || !isFull)
          "
          :size="'large'"
          :is-loading="isLoading"
          :disabled="isLoading"
          @click="approve(itemData)"
          >{{ isLoading ? "Approving" : "Approve" }}</input-button
        >
        <input-button
          v-else-if="
            $store.state.isLogin &&
            itemData.account.isApproved &&
            itemData.account.staked <= 0 &&
            (!isFinished || !isFull)
          "
          :size="'large'"
          :disabled="isFinished || isFull"
          @click="deposit(itemData)"
          >STAKE</input-button
        >
        <input-button
          v-else
          :size="'large'"
          @click="openModal('modal-connect-wallet')"
          >Connect Wallet</input-button
        >
      </p>
    </template>

    <template #detail>
      <span class="detail__data__total">
        <span>Total staked:</span>
        <span
          >{{ toFormattedToken(itemData.totalStakingTokens) }}
          {{ itemData.stakeTokenSymbol }}</span
        >
      </span>
      <span class="detail__data__link"
        ><a :href="itemData.url" target="_blank"
          >View Contract<svg-icon class="icon" :icon="'new_window'" /></a
      ></span>
      <span class="detail__data__link"
        ><a href="#" @click.prevent="addToMetamask"
          >Add to Metamask<svg-icon class="icon" :icon="'new_window'" /><img
            src="/assets/sf/icon/wallet-metamask.svg"
            alt="metamask"
            class="wallet-icon" /></a
      ></span>
    </template>
  </wallet-card>
</template>

<script>
import InputButton from "@/components/atoms/InputButton";
import SvgIcon from "@/components/atoms/SvgIcon";
import WalletCard from "@/components/molecules/WalletCard";
import { addToMetamask, getPools } from "@/utils/staking";
import token from "@/domain/staking/token";
import { MAX_UINT256 } from "@/utils/constants";
import numFormat from "number-format.js";

export default {
  name: "StakingCard",
  components: {
    InputButton,
    SvgIcon,
    WalletCard,
  },
  props: {
    itemData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDetail: false,
      isLoading: false,
      checkStatusInterval: null,
    };
  },
  computed: {
    isFull() {
      return this.web3.instance.utils
        .toBN(this.itemData.maxStakingTokens)
        .sub(this.web3.instance.utils.toBN(this.itemData.totalStakingTokens))
        .lt(this.web3.instance.utils.toBN(this.itemData.minDepositAmount));
    },
    isFinished() {
      return this.itemData.isFinished;
    },
    account() {
      return this.$store.state.account;
    },
    web3() {
      return this.$store.state.web3;
    },
  },
  methods: {
    toFormattedToken(num) {
      return numFormat(
        "#,##0.00000",
        this.web3.instance.utils.fromWei(num, "ether")
      );
    },
    toFormattedApr(num) {
      return numFormat("#,##0.00", num);
    },
    openModal(target) {
      this.$store.dispatch("openModal", target);
    },
    deposit(stakingPool) {
      this.$store.dispatch("deposit/updateStakingPool", stakingPool);
      this.account.balance == 0
        ? this.$store.dispatch("openModal", "get-token-modal")
        : this.$store.dispatch("openModal", "stake-modal");
    },
    withdraw(stakingPool) {
      this.$store.dispatch("withdraw/updateStakingPool", stakingPool);
      this.$store.dispatch("openModal", "unstake-modal");
    },
    harvest(stakingPool) {
      this.$store.dispatch("harvest/updateStakingPool", stakingPool);
      this.$store.dispatch("openModal", "staking-harvest-modal");
    },
    approve(stakingPool) {
      this.isLoading = true;

      const accountAddress = this.account.address;

      let tokenContract = new this.web3.instance.eth.Contract(
        token.abi,
        token.contractAddress
      );

      tokenContract.methods
        .approve(stakingPool.stakeContractAddress, MAX_UINT256)
        .send({ from: accountAddress })
        .on("transactionHash", (transactionHash) => {
          this.checkTransactionStatus(transactionHash, 3);
        })
        .on("error", () => {
          this.incompleteTransaction();
        });
    },
    checkTransactionStatus(transactionHash, seconds) {
      this.checkStatus = setInterval(() => {
        this.web3.instance.eth
          .getTransactionReceipt(transactionHash)
          .then((result) => {
            if (result) {
              if (result.status) {
                clearInterval(this.checkStatus);
                this.completeTransaction();
              }
            }
          });
      }, seconds * 1000);
    },
    completeTransaction() {
      getPools(this.web3.instance, this.account.address).then((result) => {
        this.$store.dispatch("stakingPools/updatePools", result);

        this.isLoading = false;

        this.$store.dispatch("toast/updateToast", {
          type: "success",
          title: "Contract Enabled",
          message: `You can now stake in the ${this.itemData.stakeTokenSymbol} pool!`,
        });
      });
    },
    incompleteTransaction() {
      this.isLoading = false;

      this.$store.dispatch("toast/updateToast", {
        type: "error",
        title: "Canceled",
        message: "Please try again and confirm the transaction.",
      });
    },
    async addToMetamask() {
      let isAdded = await addToMetamask(this.web3.instance);
      if (isAdded) {
        this.$store.dispatch("toast/updateToast", {
          type: "success",
          title: "Added Token",
          message: "Token has been added to metamask.",
        });
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.checkStatusInterval);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.header {
  &__title {
    font-size: 1.8rem;
    font-weight: 800;
    grid-column: 2;
    line-height: 1.2;
  }
  &__note {
    font-weight: 600;
    color: $color-font-note;
    grid-row: 2;
    grid-column: 2;
    font-size: 1.2rem;
  }
  &__tag {
    font-size: 1.1rem;
    height: 32px;
    line-height: 28px;
    border: 2px solid;
    padding: 0 16px;
    border-radius: 16px;
    display: inline-block;
    font-weight: bold;
    grid-column: 3;
  }
  &__icon {
    width: 54px;
    height: 54px;
    display: block;
    border-radius: 50%;
    grid-row: 1/3;
  }
}
.body-box {
  display: grid;
  grid-template-columns: 1fr auto;

  &--earned {
    margin-bottom: 40px;
  }
  &--staked {
    margin-bottom: 24px;
  }
  &__label {
    display: block;
    font-weight: 600;
    color: $color-primary;
    margin-bottom: 8px;
    grid-column: 1/3;
    font-size: 1.2rem;
  }
  &__num {
    font-size: 1.7rem;
    font-weight: 700;
    align-self: center;

    &.--none {
      color: $color-disabled;
    }
  }
}
.apy {
  display: grid;
  grid-template-columns: 1fr auto;
  margin-bottom: 32px;
  font-size: 1.6rem;

  &__label {
    font-weight: 600;
  }
  &__num {
    font-weight: 500;
  }
}
.staked-buttons {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr 1fr;
}
.staked-button {
  font-size: 0;
  background: $gradation-horizontal;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding: 3px;

  .icon {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    fill: var(--color_bg_parts);
  }
}
.detail {
  &__data {
    &__total {
      margin-bottom: 24px;
      display: flex;
      justify-content: space-between;
    }
    &__link {
      display: block;
      text-align: right;

      &:not(:last-child) {
        margin-bottom: 1em;
      }
      a {
        color: $color-font-note;
      }
      .icon {
        width: 0.85em;
        height: 0.85em;
        fill: $color-link;
        display: inline-block;
        vertical-align: middle;
        margin: -0.2em 0 0 8px;
      }
      .wallet-icon {
        width: 1.5em;
        height: 1.5em;
        display: inline-block;
        vertical-align: middle;
        margin: -0.2em 0 0 8px;
      }
    }
  }
}
.finishedribbon {
  background-color: rgb(189, 194, 196);
  color: white;
  margin: 0px;
  padding: 6px 0px;
  position: absolute;
  right: -30px;
  top: -30px;
  text-align: center;
  transform: translateX(30%) translateY(0%) rotate(45deg);
  transform-origin: left top;
  width: 180px;
}

.finishedribbon::before {
  right: 100%;
}

.fimishedtape::after {
  left: 100%;
}

.finishedribbon > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 180px;
}

.wallet-card {
  background: var(--color_bg_parts);
  border-radius: 20px;
  box-shadow: 0 0 15px #ccc;
  position: relative;
  overflow: hidden;
}
</style>